module.exports = __webpack_public_path__ + "static/media/union_card_icon.202c1191.png";